import React from 'react';
import PropTypes from 'prop-types';
import { ONBOARDING_PASSWORD_SHOW, ONBOARDING_PASSWORD_HIDE } from '../../../constants/Copy';

import './PasswordVisibilityToggle.scss';

const PasswordVisibilityToggle = ({ onClick, show }) => (
	<a onClick={onClick} className="password-toggle">
		{show ? ONBOARDING_PASSWORD_HIDE : ONBOARDING_PASSWORD_SHOW}
	</a>
);

PasswordVisibilityToggle.propTypes = {
	onClick: PropTypes.func.isRequired,
	show: PropTypes.bool.isRequired,
};

export default PasswordVisibilityToggle;
